<template>
    <Modal v-model="show"
           :mask-closable="false"
           :loading="loading"
           :title="`${$t('绑定到主机')}`">
        <Form ref="form"
              label-position="right"
              :model="fromData"
              :rules="validate"
              :label-width="100">
            <FormItem :label="`${$t('弹性IP')}:`">
                {{floatIpData.ip}}
            </FormItem>
            <div v-if="envTypeList.includes(floatIpData.envType)">
                <FormItem :label="`${$t('类型')}:`">
                    <Select v-model="fromData.instanceType">
                        <Option v-for="t in types"
                                :key="t.id"
                                :value="t.id">{{t.name}}</Option>
                    </Select>
                </FormItem>
                <FormItem :label="`${$t('资源')}:`"
                          v-if="fromData.instanceType==='RES-HOST'"
                          prop="instanceId">
                    <Select v-model="fromData.instanceId">
                        <Option v-for="host in hosts"
                                :key="host.id"
                                :value="`${host.id}`">{{host.instanceName}}</Option>
                    </Select>
                </FormItem>

                <FormItem :label="`${$t('资源')}:`"
                          v-else-if="fromData.instanceType==='RES-SLB'"
                          prop="lbId">
                    <Select v-model="fromData.lbId">
                        <Option v-for="slb in slbs"
                                :key="slb.id"
                                :value="`${slb.id}`">{{slb.lbName}}</Option>
                    </Select>
                </FormItem>
            </div>
            <FormItem v-else
                      :label="`${$t('服务器')}:`"
                      prop="instanceId">
                <Select v-model="fromData.instanceId">
                    <Option v-for="host in hosts"
                            :key="host.id"
                            :value="host.id">{{host.instanceName}}</Option>
                </Select>
            </FormItem>
        </Form>
        <div class="submit"
             slot="footer">
            <Button @click="closeModal"
                    type="text"
                    style="margin-left: 8px">{{$t('取消')}}</Button>
            <Button type="primary"
                    :loading="loading"
                    @click="submit">{{!loading ? $t('确定') : $t('保存中')}}</Button>
        </div>
    </modal>
</template>
<script>
import API from '@/service/api'
export default {
    name: 'floatIpBinding',
    data () {
        return {
            envTypeList: ['OpenStack', 'OpenStack-Admin', 'ESCloud', 'ESCloud-Admin', 'CloudOS', 'Nine9Cloud', 'Nine9Cloud-Admin'],
            show: false,
            loading: false,
            fromData: {
                instanceType: '',
                instanceId: '',
                lbId: ''
            },
            type: null,
            floatIpData: {},
            validate: {
                instanceId: { required: true, message: '请选择服务器', trigger: 'change' },
                lbId: { required: true, message: '请选择负载均衡', trigger: 'change' }
            },
            hosts: [],
            slbs: [],
            types: [
                { id: 'RES-HOST', name: '服务器' },
                { id: 'RES-SLB', name: '负载均衡' }
            ]
        }
    },
    methods: {
        closeModal () {
            this.$refs.form.resetFields()
            this.loading = false
            this.show = false
        },
        open (data) {
            this.floatIpData = data
            this.init()
            if (this.envTypeList.includes(this.floatIpData.envType)) {
                this.fromData.instanceType = 'RES-HOST'
            }
            this.show = true
        },
        init () {
            const params = {
                envId: this.floatIpData.envId,
                publicIp: 'empty',
                status: 'ignoreStatus'
            }
            if (this.envTypeList.includes(this.floatIpData.envType)) {
                params.floatingIpBind = this.floatIpData.ip
            }
            this.axios.get(this.urlFormat(API.HOSTS, true), {
                params
            }).then(res => {
                this.hosts = res
            })
            this.axios.get(this.urlFormat(API.GET_UNBIND_LB, true), {
                params: {
                    cloudEnvId: this.floatIpData.envId
                }
            }).then(res => {
                this.slbs = res || []
            })
        },
        isOpenStacks (type, excArr) {
            let data = ['OpenStack', 'OpenStack-Admin', 'ESCloud', 'ESCloud-Admin', 'CloudOS', 'Nine9Cloud', 'Nine9Cloud-Admin']
            if (excArr !== null && excArr !== undefined && excArr.length > 0) {
                data = data.filter((item) => {
                    return !excArr.includes(item)
                })
            }
            return data.includes(type)
        },
        submit () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.loading = true
                    const fd = this.fromData
                    if (fd.instanceType === 'RES-SLB') {
                        this.axios.put(this.urlFormat(API.BIND_FLOATINGIP, true, [fd.lbId, this.floatIpData.id])).then(res => {
                            if (res) {
                                this.closeModal()
                                this.$emit('refresh')
                            } else {
                                this.loading = false
                            }
                        })
                    } else {
                        this.axios.put(this.urlFormat(API.ATTACH_FLOATIP, true), {
                            id: this.floatIpData.id,
                            instanceType: '',
                            instanceId: fd.instanceId
                        }).then(res => {
                            if (res) {
                                this.closeModal()
                                this.$emit('refresh')
                            } else {
                                this.loading = false
                            }
                        })
                    }
                }
            })
        }
    }
}
</script>
